/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { components } from 'react-select';
import { css, CSSObject, Divider } from 'theme-ui';
import rawCarrotTheme from '../../theme';
import { Container, Stack, FlexContainer } from '../..';
import { NakedSelectProps } from './SelectTypes';
import { BaseSelect } from './NakedSelect';

const customFilterStyles = () => ({
    option: (provided: CSSObject, state: any) => ({
        ...provided,
        ...css({
            variant: state.isFocused ? 'select.filter.option-focused' : 'select.filter.option-default',
        })(rawCarrotTheme),
    }),
    singleValue: (provided: CSSObject) => ({
        ...provided,
        ...css({
            variant: 'select.filter.single-value-default',
        })(rawCarrotTheme),
    }),
    control: (provided: CSSObject, state: any) => {
        const variant = ['default'];

        if (state.selectProps.error) {
            variant[0] = 'error';
        }
        if (state.isFocused) {
            variant[0] = 'focused';
        }
        if (state.isDisabled) {
            variant[1] = 'disabled';
        }
        return {
            ...provided,
            ...css({
                variant: `select.filter.control-${variant.join('-')}`,
            })(rawCarrotTheme),
        };
    },
});

const Control = ({ children, ...rest }: any) => (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <components.Control {...rest}>
        <FlexContainer
            width="100%"
            justifyContent="space-between"
            paddingTopBottom="16px"
            paddingLeftRight="12px"
            sx={{ lineHeight: '21px' }}
        >
            {children}
        </FlexContainer>
    </components.Control>
);

const MenuList = (props: any) => {
    const isSearchable = Boolean(props?.selectProps?.isSearchable);
    return (
        <Container shadow="sheet">
            <components.MenuList {...props}>
                {!isSearchable && (
                    <div sx={{ variant: 'select.filter.option' }}>
                        <Stack spacing="16px">
                            <span>{props.selectProps.placeholder || 'Select option'}</span>
                            <Divider />
                        </Stack>
                    </div>
                )}
                {props.children}
            </components.MenuList>
        </Container>
    );
};

export default function NakedFilterSelect(props: NakedSelectProps): JSX.Element {
    return (
        <BaseSelect
            componentOverrides={{
                Control,
                MenuList,
            }}
            styleOverride={customFilterStyles}
            {...props}
        />
    );
}
